import { render, staticRenderFns } from "./addbanner.vue?vue&type=template&id=0d56dcdf&scoped=true&"
import script from "./addbanner.vue?vue&type=script&lang=js&"
export * from "./addbanner.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./addbanner.vue?vue&type=style&index=1&id=0d56dcdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d56dcdf",
  null
  
)

export default component.exports